import { api } from '@/lib/api/client';
import type { IntakeFieldConfig } from './types';

/**
 * GET /api/intake-config — the admin-configurable set of demographic fields
 * shown on Register (which fields exist, their order, and whether each is
 * mandatory/optional/hidden). A bare array, legacy route, tenant-wide.
 */
export function fetchIntakeConfig(): Promise<IntakeFieldConfig[]> {
  return api.get('/intake-config');
}
